import { SCode, StatusHistoryConditionType } from '../constants';
import type { SelectedTimezoneModel } from '../../store/models/local-date.model';

export enum StatusHistoryOriginEnum {
  ShipsGo = 'SHIPSGO',
  ShippeoETA = 'SHIPPEO_ETA',
  Iftsta = 'IFTSTA',
  IftstaManual = 'IFTSTA_MANUAL',
  GeoFence = 'GEO_FENCE',
  Ml = 'ML',
  ManualAdaptation = 'MANUAL_ADAPTATION',
  SHIPPEO = 'SHIPPEO',
  DriverApp = 'DRIVER_APP',
  Dhl = 'DHL',
  Idle = 'IDLE',
}

export enum StatusHistoryBestfitOriginEnum {
  LSP = 'LSP',
  ML = 'INTRACK_ML',
  SG = 'INTRACK_SHIPSGO',
}

export class StatusHistoryDates {
  receivedDateTime: DateWithTimezones | null = null;
  estimatedDateTime: DateWithTimezones | null = null;
  intrackEstimatedDateTime: DateWithTimezones | null = null;
  shipsGoEstimatedDateTime: DateWithTimezones | null = null;
  bestfitEstimatedDateTime: DateWithTimezones | null = null;
  actualDateTime: DateWithTimezones | null = null;
  bestfitOrigin: StatusHistoryBestfitOriginEnum;
  origin: StatusHistoryOriginEnum;
}

export class DateWithTimezones {
  timestamp: number;
  profileTimezoneData: SelectedTimezoneModel;
  localTimezoneData: SelectedTimezoneModel;
}

export class StatusHistoryChainModel {
  statusCode: SCode;
  statusCodeDescription: string;
  condition: StatusHistoryConditionType;
  dates: StatusHistoryDates[];
}
